import { clampNumberUtil } from 'packages/src'
import { RATE_OF_PERCEIVED_EXERTION } from '../../../../../constant'
import { SET_DATA_KEY } from '../../constants'
import {
  getRepsFromDurationSetDataUtil,
  getSetDurationSetDataUtil
} from '../get-set-duration'
import {
  getTypeExerciseUtil,
  isBreathingExerciseUtil,
  isWarmUpOrStretchingExerciseUtil
} from '../../../../exercise/model/utils'
import { EXERCISE_TYPE } from '../../../../exercise/model/constants'
import { isWarmUpOrStretchingWorkoutSectionUtil } from '../../../../workout-section'
import { getWeightFromRepsAndOneRepMaxExerciseLogSummaryUtil } from '../../../../exercise-log-summary/model/utils'

const EXERCISE_TYPE_TO_RATE_OF_PERCEIVED_EXERTION = {
  [EXERCISE_TYPE.STRENGTH]: RATE_OF_PERCEIVED_EXERTION.MODERATE,
  [EXERCISE_TYPE.POWERLIFTING]: RATE_OF_PERCEIVED_EXERTION.MODERATE,
  [EXERCISE_TYPE.OLYMPIC_WEIGHTLIFTING]: RATE_OF_PERCEIVED_EXERTION.MODERATE, // [EXERCISE_TYPE.STRONGMAN]:
  // RATE_OF_PERCEIVED_EXERTION.MODERATE,
  [EXERCISE_TYPE.PLYOMETRIC]: RATE_OF_PERCEIVED_EXERTION.VERY_VIGOROUS,
  [EXERCISE_TYPE.CARDIO]: RATE_OF_PERCEIVED_EXERTION.MODERATE,
  [EXERCISE_TYPE.CONDITIONING]: RATE_OF_PERCEIVED_EXERTION.MODERATE,
  [EXERCISE_TYPE.STRETCHING]: RATE_OF_PERCEIVED_EXERTION.LIGHT,
  [EXERCISE_TYPE.BALANCE]: RATE_OF_PERCEIVED_EXERTION.LIGHT,
  [EXERCISE_TYPE.SMR]: RATE_OF_PERCEIVED_EXERTION.VERY_LIGHT,
  [EXERCISE_TYPE.WARMUP]: RATE_OF_PERCEIVED_EXERTION.LIGHT,
  [EXERCISE_TYPE.YOGA]: RATE_OF_PERCEIVED_EXERTION.MODERATE,
  [EXERCISE_TYPE.ACTIVITY]: RATE_OF_PERCEIVED_EXERTION.MODERATE
}

function getEstimatedRateOfPerceivedExertionSetDataUtil (params) {
  const {
    exerciseLogSummary,
    set,
    workoutSection,
    exercise
  } = params

  // It is an effective set if:
  // - It is not a rest
  // - It is not a warm up / stretching
  if (set[SET_DATA_KEY.REST] !=
    null ||
    isWarmUpOrStretchingExerciseUtil(exercise) ||
    isWarmUpOrStretchingWorkoutSectionUtil(workoutSection) ||
    isBreathingExerciseUtil(exercise)) {
    return RATE_OF_PERCEIVED_EXERTION.VERY_LIGHT
  }

  // TODO handle metabolic equivalent
  let rpe = (
    set[SET_DATA_KEY.ESTIMATED_RATE_OF_PERCEIVED_EXERTION] ||
    set[SET_DATA_KEY.RATE_OF_PERCEIVED_EXERTION]
  )

  const weight = set[SET_DATA_KEY.WEIGHT]
  // Calculate the RPE based on the 1RM
  if (!rpe && exerciseLogSummary && weight) {
    const newWeight = (
      getWeightFromRepsAndOneRepMaxExerciseLogSummaryUtil(
        exerciseLogSummary,
        getRepsFromDurationSetDataUtil(getSetDurationSetDataUtil(set)),
        weight
      )
    )
    const newWeightPercentage = (
      (
        newWeight * 100
      ) / weight
    )
    rpe = (
      newWeightPercentage * RATE_OF_PERCEIVED_EXERTION.MAXIMAL_EFFORT
    ) / 100
    rpe = clampNumberUtil(rpe, 1, 10)
  }

  // No weight, default rpe
  if (!rpe || Number.isNaN(rpe)) {
    const exerciseType = getTypeExerciseUtil(exercise)
    rpe = (
      EXERCISE_TYPE_TO_RATE_OF_PERCEIVED_EXERTION[exerciseType] ||
      RATE_OF_PERCEIVED_EXERTION.MODERATE
    )
  }

  return rpe
}

export { getEstimatedRateOfPerceivedExertionSetDataUtil }
